export function webComponents(): string {
    return 'web-components';
}
